import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorResponse } from 'src/app/models/error-response';
import { ErrorService } from '../services/error/error.service';
import { LoadingService } from '../services/loading/loading.service';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  constructor(
    private errorService: ErrorService,
    private loadingService: LoadingService, 
    private router: Router,
    private ngZone: NgZone) {}


  handleError = (error: any) => this.ShowError(error);

  //TODO: handle no request errors
  private ShowError = (error: any) =>
    error instanceof HttpErrorResponse &&
    (() => { 

      this.errorService.error = error?.error as ErrorResponse;
      this.loadingService.hide();
      this.ngZone.run(() =>  this.router.navigate(['error']));

    })();
}
